import Splide from '@splidejs/splide';

// would like this to be dynamically imported

document.addEventListener('DOMContentLoaded', () => {
    
    const featuredProjectsSliderArray = document.querySelectorAll('.js-featuredProjectsSlider');

    featuredProjectsSliderArray.forEach(slider => {
        const featuredProjectsSlider = new Splide(slider, {
            perPage: 1,
            perMove: 1,
            pagination: false,
            autoHeight: false,
            speed: 500,
            easing: 'ease-in-out',
            type: 'fade',
        });
        featuredProjectsSlider.mount();
    });

})

